import styled from "styled-components";

export const Styles = styled.div`
  padding: 10px;
  font-family: "Yu Gothic", "Hiragino Sans", "Hiragino Kaku Gothic ProN",
    "Noto Sans JP", "Meiryo", -apple-system, BlinkMacSystemFont, sans-serif;
  background: white;
  color: #333;

  /* Force all children to inherit Japanese-capable font */
  * {
    font-family: inherit !important;
  }

  /* Table hack for repeating top margins without browser headers */
  .pdf-print-table {
    width: 100%;
    border-collapse: collapse;
    border: none;
  }
  .pdf-print-table > thead > tr > td,
  .pdf-print-table > tbody > tr > td {
    padding: 0;
    border: none;
  }
  .pdf-print-header-space {
    height: 4mm;
  }

  /* Compact label container for PDF */
  .label_container {
    min-height: 40px !important;
    margin-top: 2px !important;
    margin-bottom: 2px !important;
    display: flex;
    align-items: center;
  }

  .ant-form .ant-form-item {
    margin-bottom: 4px !important;
  }

  .layout-grid-item div {
    overflow: visible !important;
    text-overflow: unset !important;
    white-space: normal !important;
    word-break: keep-all !important;
  }

  /* Allow page break to happen naturally within grid items/containers */
  .layout-grid-container,
  .layout-grid-item,
  .ant-form-item {
    break-inside: auto !important;
    page-break-inside: auto !important;
  }

  /* Keep table rows intact during page breaks */
  .table-div__row {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }

  /* ===== HIDE: Buttons, action panels ===== */
  button,
  .ant-btn,
  .button,
  .button-collapse,
  .action-buttons-container,
  .action_cell {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    opacity: 0 !important;
  }

  /* ===== HIDE: Table outer borders ===== */
  .table-div,
  .table-div__body,
  .table-div__row,
  .table-div__cell,
  .is-table,
  .layout-grid-item.is-table {
    border: none !important;
    border-width: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    outline: none !important;
  }

  /* Force tables and rows in PDF to take full width */
  .table-div,
  .table-div__body {
    display: block !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
  }

  .table-div__row {
    display: grid !important;
    width: 100% !important;
    height: auto !important;
    min-height: unset !important;
    align-items: flex-start !important;
    border: none !important;
  }

  .table-div__cell {
    border: none !important;
    padding: 4px 8px !important;
    height: auto !important;
  }

  /* Allow multiline text in inputs/textareas, with reasonable max-height for PDF */
  .ant-input,
  .ant-input-textarea,
  textarea,
  .ant-select,
  .ant-select-selector,
  .ant-picker,
  .ant-picker-input,
  .ant-form-item-control-input,
  .ant-form-item-control-input-content {
    height: auto !important;
    min-height: unset !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible !important;
  }

  textarea {
    field-sizing: content !important;
  }

  /* ===== HIDE: Pulldown arrows / suffix icons ===== */
  .ant-select-arrow,
  .ant-select-suffix,
  .ant-select-arrow-icon,
  .select-arrow,
  .suffix-icon,
  .ant-picker-suffix,
  .ant-picker-clear,
  svg[class*="arrow"],
  svg[class*="down"],
  svg[class*="pulldown"],
  .icon-pulldown {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }

  /* ===== HIDE: Scrollbars ===== */
  *::-webkit-scrollbar {
    display: none !important;
  }
  * {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  /* ===== HIDE: Upload drag zone + paste input, keep file list ===== */
  .ant-upload.ant-upload-drag {
    display: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
  }

  /* ===== @media print overrides ===== */
  @media print {
    .ant-form .ant-form-item {
      margin-bottom: 2px !important;
    }

    .ant-form-item-control-input,
    .ant-form-item-control-input-content,
    .ant-input,
    .ant-select,
    .ant-picker {
      min-height: unset !important;
    }

    .label_container {
      min-height: unset !important;
      margin-top: 2px !important;
      margin-bottom: 2px !important;
    }

    .table-div__body .table-div__row {
      align-items: flex-start !important;
    }

    .table-div__body .table-div__row:not(:first-child) .table-div__cell {
      align-items: flex-start !important;
    }

    .table-div__body .table-div__row:first-child .table-div__cell {
      align-items: flex-start !important;
    }
  }
`;
